<ngx-spinner [name]="name"
             [fullScreen]="fullscreen"
             [size]="size"
             [color]="color"
             type="ball-clip-rotate">
</ngx-spinner>
